import { render, staticRenderFns } from "./newCoinDetail.vue?vue&type=template&id=0868b980&scoped=true&"
import script from "./newCoinDetail.vue?vue&type=script&lang=js&"
export * from "./newCoinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868b980",
  null
  
)

export default component.exports